import React from 'react';
import FianceCard from './FianceCard';
import { GENERO, ESTADO_CIVIL } from '../../constants/scoringConstants';
import { formatDateInput } from '../../utils/inputValidation';

const PROVINCIAS = [
    'Buenos Aires', 'CABA', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba',
    'Corrientes', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja',
    'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan',
    'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'
];

const ApoderadoForm = ({ formData, setFormData, caseType }) => {
    const isStored = caseType === 'STORED';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const inputClass = (stored) =>
        `w-full px-3 py-2 border border-gray-200 rounded-md text-gray-800 text-sm focus:outline-none transition-all duration-200 ${stored
            ? 'bg-gray-100 cursor-default'
            : 'bg-gray-50 focus:border-honda-500 focus:ring-1 focus:ring-honda-500'
        }`;

    const isCasado = formData.apodEstadoCivil === '2';

    return (
        <>
        <div className="mb-6 bg-white border-2 border-gray-100 rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden group">
            <div className="h-1.5 gradient-red group-hover:h-2 transition-all duration-300"></div>
            <div className="bg-gradient-to-br from-honda-50 to-white px-6 py-4 border-b border-gray-100">
                <h3 className="text-sm font-bold text-honda-800 uppercase tracking-wide flex items-center gap-2">
                    <span className="material-icons text-honda-600">person_pin</span>
                    DATOS DEL APODERADO
                </h3>
            </div>
            <div className="p-4">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    <div className="md:col-span-2">
                        <label className="block text-xs font-medium text-gray-500 mb-1">Nombre Completo <span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            name="apodNombre"
                            value={formData.apodNombre || ''}
                            onChange={handleChange}
                            readOnly={isStored}
                            placeholder="Nombre y Apellido"
                            className={inputClass(isStored)}
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">DNI <span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            name="apodDni"
                            value={formData.apodDni || ''}
                            onChange={handleChange}
                            readOnly={isStored}
                            placeholder="DNI"
                            className={inputClass(isStored)}
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Fecha de Nacimiento <span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            name="apodFechaNacimiento"
                            value={formData.apodFechaNacimiento || ''}
                            onChange={(e) => {
                                if (isStored) return;
                                setFormData(prev => ({ ...prev, apodFechaNacimiento: formatDateInput(e.target.value) }));
                            }}
                            readOnly={isStored}
                            placeholder="dd/mm/aaaa"
                            maxLength="10"
                            className={inputClass(isStored)}
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Estado Civil <span className="text-red-500">*</span></label>
                        <select
                            name="apodEstadoCivil"
                            value={formData.apodEstadoCivil || ''}
                            onChange={handleChange}
                            disabled={isStored}
                            className={inputClass(isStored)}
                        >
                            <option value="">Seleccione...</option>
                            {ESTADO_CIVIL.map(item => (
                                <option key={item.id} value={item.id}>{item.id} - {item.descripcion}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Género <span className="text-red-500">*</span> <span className="text-honda-700">(según DNI)</span></label>
                        <select
                            name="apodSexo"
                            value={formData.apodSexo || ''}
                            onChange={handleChange}
                            disabled={isStored}
                            className={inputClass(isStored)}
                        >
                            <option value="">Seleccione...</option>
                            {GENERO.map(item => (
                                <option key={item.id} value={item.id}>{item.id} - {item.descripcion}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Nacionalidad <span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            name="apodNacionalidad"
                            value={formData.apodNacionalidad || ''}
                            onChange={handleChange}
                            readOnly={isStored}
                            placeholder="Nacionalidad"
                            className={inputClass(isStored)}
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">PEP <span className="text-red-500">*</span></label>
                        <select
                            name="apodPep"
                            value={formData.apodPep || ''}
                            onChange={handleChange}
                            disabled={isStored}
                            className={inputClass(isStored)}
                        >
                            <option value="">Seleccione...</option>
                            <option value="NO">NO</option>
                            <option value="SI">SI</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        {/* Cónyuge del Apoderado */}
        {isCasado && (
            <FianceCard
                data={formData}
                setData={setFormData}
                prefix="apodFiance"
            />
        )}

        {/* DIRECCIÓN DEL APODERADO */}
        <div className="mb-6 bg-white border-2 border-gray-100 rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden group">
            <div className="h-1.5 gradient-red group-hover:h-2 transition-all duration-300"></div>
            <div className="bg-gradient-to-br from-honda-50 to-white px-6 py-4 border-b border-gray-100">
                <h3 className="text-sm font-bold text-honda-800 uppercase tracking-wide flex items-center gap-2">
                    <span className="material-icons text-honda-600">location_on</span>
                    DIRECCIÓN DEL APODERADO
                </h3>
            </div>
            <div className="p-4">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Dirección <span className="text-red-500">*</span></label>
                        <input type="text" name="apodDireccion" value={formData.apodDireccion || ''} onChange={handleChange} readOnly={isStored} placeholder="Calle" className={inputClass(isStored)} />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Número <span className="text-red-500">*</span></label>
                        <input type="text" name="apodNumero" value={formData.apodNumero || ''} onChange={handleChange} readOnly={isStored} placeholder="Número" className={inputClass(isStored)} />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Piso / Dpto</label>
                        <input type="text" name="apodPiso" value={formData.apodPiso || ''} onChange={handleChange} readOnly={isStored} placeholder="Piso / Dpto" className={inputClass(isStored)} />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Código Postal <span className="text-red-500">*</span></label>
                        <input type="text" name="apodCodigoPostal" value={formData.apodCodigoPostal || ''} onChange={handleChange} readOnly={isStored} placeholder="Código Postal" className={inputClass(isStored)} />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Localidad <span className="text-red-500">*</span></label>
                        <input type="text" name="apodLocalidad" value={formData.apodLocalidad || ''} onChange={handleChange} readOnly={isStored} placeholder="Ciudad/Localidad" className={inputClass(isStored)} />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Provincia <span className="text-red-500">*</span></label>
                        <select name="apodProvincia" value={formData.apodProvincia || ''} onChange={handleChange} disabled={isStored} className={inputClass(isStored)}>
                            <option value="">Seleccione...</option>
                            {PROVINCIAS.map(p => <option key={p} value={p}>{p}</option>)}
                        </select>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ApoderadoForm;
